import React from 'react';
import { BpPlay } from 'models/tagging/BpPlay';
import { LinearLoader } from 'components/ui/LinearLoader/LinearLoader';
import { BpPlaceholderPlayWrapper, Text } from './BpPlaceholderPlayStyles';

interface IProps {
  isHidden: boolean;
  isSelected: boolean;
  play: BpPlay;
  onClick: (play: BpPlay) => void;
}

export const BpPlaceholderPlay: React.FC<IProps> = ({ isHidden, onClick, play, isSelected }) => {
  return (
    <BpPlaceholderPlayWrapper className={`${isHidden ? ' hidden' : ''}${isSelected ? ' selected' : ''}`} onClick={() => onClick(play)}>
      <Text>Waiting</Text>
      <LinearLoader />
    </BpPlaceholderPlayWrapper>
  );
};
